import { render } from "./SpecialOfferNotification.vue?vue&type=template&id=62ff24ad&scoped=true"
import script from "./SpecialOfferNotification.vue?vue&type=script&lang=js"
export * from "./SpecialOfferNotification.vue?vue&type=script&lang=js"

import "./SpecialOfferNotification.vue?vue&type=style&index=0&id=62ff24ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ff24ad"]])

export default __exports__